module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"tool-title":"Piézomètre virtuel","HEADS-label":"Niveau [msm]","HEADS-unit":"msm","EZNS-label":"Profondeur [m]","EZNS-unit":"m","no-data-title":"Aucune donnée","HEADS":"Niveau piézométrique","EZNS":"Épaisseur de la zone non saturée","reference-title":"Valeurs de référence (1976-2017)","catalog-title":"Catalogue mensuel"},"de":{}}')
  delete Component.options._Ctor
}
